import { Box, Container, Flex, Heading, Image, Link, ListItem, SimpleGrid, Text, UnorderedList } from '@chakra-ui/react'
import LATEST_PROJECTS from '../../constants/latest-projects'
import { FiChevronRight } from 'react-icons/fi'

const Portfolio = () => {
  return (
    <Box
      id="projects"
      py={{
        base: 14,
        md: 20
      }}
      bgColor={'black'}
      // background="linear-gradient(150deg, #16222a, #3a6073)"
    >
      <Container maxW={'container.xl'}>
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={2}
          mb={{
            base: 6,
            md: 14
          }}>
          <Heading
            textAlign={{
              md: 'center'
            }}
            color={'white'}
            fontSize={{
              base: '1.25rem',
              md: '2rem'
            }}>
            {LATEST_PROJECTS.title}
          </Heading>
          <Text
            textAlign={{
              md: 'center'
            }}
            color={'white'}
            fontSize={{
              base: '1rem',
              md: '1rem'
            }}>
            Here are some key projects I've worked on, reflecting my expertise and passion for technology.
          </Text>
        </Box>

        <SimpleGrid
          columns={{
            base: 1,
            md: 2
          }}
          spacing={{
            base: 10,
            md: 20
          }}>
          {LATEST_PROJECTS.data.map((project, i) => {
            return (
              <Box key={i} color={'white'}>
                <Image
                  src={project.image}
                  w={{
                    base: 'auto'
                  }}
                  h={'auto'}
                  objectFit={'contain'}
                  bgColor={'gray.100'}
                  borderRadius={'md'}
                  alt="Project image"
                  width={'auto'}
                  height={'auto'}
                />
                <Box
                  py={{
                    base: 2,
                    lg: 5
                  }}>
                  <Heading
                    as={'h2'}
                    fontSize={{
                      base: '1.1rem',
                      lg: '1.5rem'
                    }}
                    // noOfLines={1}
                  >
                    {project.project_name}
                  </Heading>

                  <Text
                    fontSize={{
                      base: '.85rem',
                      lg: '1rem'
                    }}
                    color={'gray.400'}>
                    {project.duration}
                  </Text>

                  <Flex
                    mt={{
                      base: 3,
                      md: 3
                    }}
                    mb={{
                      base: 4,
                      md: 4
                    }}>
                    <Link
                      href={project.link}
                      isExternal
                      backgroundColor={'white'}
                      py={{
                        base: 1
                      }}
                      px={{
                        base: 4
                      }}
                      color={'black'}
                      borderRadius={'full'}
                      fontSize={{
                        base: '1rem',
                        lg: '1rem'
                      }}
                      fontWeight={'600'}
                      _hover={{
                        boxShadow: '0 2px 20px -10px rgba(0,0,0,0.95)',
                        color: 'green.600'
                      }}
                      display={'flex'}
                      alignItems={'center'}
                      gap={1}>
                      Show Project
                      <FiChevronRight />
                    </Link>
                  </Flex>

                  <Text
                    fontSize={{
                      base: '1rem',
                      lg: '1rem'
                    }}
                    fontWeight={'500'}>
                    {project.description}
                  </Text>

                  <UnorderedList
                    fontSize={{
                      base: '1rem',
                      lg: '1rem'
                    }}
                    color={'white'}
                    fontWeight={'500'}
                    pl={4}>
                    {project.jobs.map((job, i) => (
                      <ListItem key={i}>✅ {job}</ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </Box>
            )
          })}
        </SimpleGrid>
      </Container>
    </Box>
  )
}

export default Portfolio
